import { create } from 'zustand';

interface CollapsibleNavbarStore {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (isSidebarOpen: boolean) => void;
}

export const useCollapsibleNavbarStore = create<CollapsibleNavbarStore>((set) => ({
  isSidebarOpen: true,
  setIsSidebarOpen: (isSidebarOpen: boolean) => set({ isSidebarOpen }),
}));
